import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import {DrawerTitle as RmwcDrawerTitle} from '@rmwc/drawer'
import '@rmwc/drawer/styles'

const StyledRmwcDrawerTitle = styled(RmwcDrawerTitle)`
  &&& {
    font-family: 'Inter', sans-serif;
    font-size: 28px;
    font-weight: 700;
    line-height: 38.19px;
    margin-top: -3rem;
    margin-bottom: -3rem;
  }
  .mdc-theme--on-primary2 &&& {
    color: var(--mdc-theme-on-primary2);
  }
`

const DrawerTitle = ({children, ...otherProps}) => <StyledRmwcDrawerTitle {...otherProps}>{children}</StyledRmwcDrawerTitle>

DrawerTitle.propTypes = {
  children: PropTypes.any
}

export {DrawerTitle}
